import React, { Component } from 'react';
import logo from './img/gear.svg';
import './css/App.css';
import './css/robot.css';
import TeamList from './components/teamlist.js';
import robotData from './data/robotData.js';

class App extends Component {
  constructor(props) {
    super(props);

    const teamsParsed = {};
    robotData.forEach((robot) => {
      if (!teamsParsed[robot.userName]) {
        teamsParsed[robot.userName] = {
          teamName: robot.teamName,
          userName: robot.userName,
          postURL: robot.postURL,
          robots:[],
        }
      }
      teamsParsed[robot.userName]['robots'].push({
        robotName: robot.robotName,
        weightClass: robot.weightClass,
        imageURL: robot.imageURL,
        speed: robot.speed,
        traction: robot.traction,
        torque: robot.torque,
        weapon: robot.weapon,
        armor: robot.armor,
        altConfig: robot.altConfig,
      })
    });

    this.state = {
      teams: {...teamsParsed},      
    };
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Ruination: The Upheaval</h1>
          <p className="App-intro">
            A visual guide to the competitors.
          </p>
        </header>
        <TeamList {...this.state.teams} />
      </div>
      
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js